export interface IImage {
  id?: string;
  thumbnail_name: string;
  original_name: string;
  thumbnail_url: string;
  original_url: string;
}

export class ImageDTO implements IImage {
  id?: string;
  thumbnail_name: string;
  original_name: string;
  thumbnail_url: string;
  original_url: string;
}

export default class Image extends ImageDTO {
  constructor(dto: ImageDTO) {
    super();
    Object.assign(this, dto);
  }
}
